import { Controller } from "../../Controller";
import { GetArquivoLigacaoService, ListarHistoricoLigacoesService } from "../../../Services/Geral/ContaLigacao/ContaLigacaoServices"


export async function ListarHistoricoLigacoesController(idConta: number){
    return Controller(
        ListarHistoricoLigacoesService(idConta)
    )
}

export async function GetArquivoLigacaoController(idContaLigacao: number){
    return Controller(
        GetArquivoLigacaoService(idContaLigacao)
    )
}